import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles(theme => ({
	chips: {
		display: "flex",
		flexWrap: "wrap",
	},
	chip: {
		margin: 2,
	},
	inputRoot: {
		'& .MuiOutlinedInput-root': {
			padding: '6.5px 14px',
			'& fieldset': {
				borderColor: 'rgba(0, 0, 0, 0.23)',
			},
			'&:hover fieldset': {
				borderColor: 'rgba(0, 0, 0, 0.87)',
			},
			'&.Mui-focused fieldset': {
				borderColor: theme.palette.primary.main,
				borderWidth: 2,
			},
		},
	},
}));

const UserSelect = ({ selectedUserIds, onChange, label, excludeUserId }) => {
	const classes = useStyles();
	const [users, setUsers] = useState([]);
	const { user: loggedInUser } = useContext(AuthContext);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/users");
                const users = data?.users || [];
				const usersIdToExclude = excludeUserId ? [excludeUserId, loggedInUser.id] : [loggedInUser.id];
				const filteredUsers = 
					users.filter(user => !usersIdToExclude.includes(user.id));
				setUsers(filteredUsers);
			} catch (err) {
				toastError(err);
			}
		})();
	}, [excludeUserId]);

	const handleChange = (event, newValue) => {
		const userIds = newValue.map(user => user.id);
		onChange(userIds);
	};

	const getSelectedUsers = () => {
		return users.filter(user => selectedUserIds?.includes(user.id)) || [];
	};

	return (
		<div style={{ marginTop: 6 }}>
			<Autocomplete
				multiple
				options={users}
				getOptionLabel={(option) => option.name}
				value={getSelectedUsers()}
				onChange={handleChange}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => (
						<Chip
							variant="outlined"
							label={option.name}
							{...getTagProps({ index })}
							className={classes.chip}
						/>
					))
				}
				renderInput={(params) => (
					<TextField
						{...params}
						variant="outlined"
						label={label || "Select Users"}
						placeholder="Search users..."
						fullWidth
						className={classes.inputRoot}
					/>
				)}
			/>
		</div>
	);
};

export default UserSelect;
